import { render } from "./digital-incorporation-form-unavailable.vue?vue&type=template&id=028a772e&scoped=true"
const script = {}

import "./digital-incorporation-form-unavailable.vue?vue&type=style&index=0&id=028a772e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028a772e"]])

export default __exports__